import React from 'react'
import PropTypes from 'prop-types'

import PreviewModalImageHoverItem from 'Components/PreviewModal/PreviewModalImageHoverItem'

const PreviewModalImage = props => (
  <div>
    {props.previous && (
      <PreviewModalImageHoverItem lightBackground={props.lightBackground} onClick={props.handleClickLeft} position="left" />
    )}

    {props.children}

    {props.next && <PreviewModalImageHoverItem lightBackground={props.lightBackground} onClick={props.handleClickRight} position="right" />}
  </div>
)

PreviewModalImage.propTypes = {
  children: PropTypes.node.isRequired,
  handleClickLeft: PropTypes.func.isRequired,
  handleClickRight: PropTypes.func.isRequired,
  lightBackground: PropTypes.bool,
  next: PropTypes.bool.isRequired,
  previous: PropTypes.bool.isRequired,
}

export default PreviewModalImage
